import { Observable } from 'rxjs'
import { MbDatasetEntry, MbProductTabExtendedValidation } from '../../../models'

export abstract class MbProductTabExtendedValidationAdapter {

  abstract load<T extends MbDatasetEntry>(productCode: string): Observable<MbProductTabExtendedValidation>
}
